import { render } from "./MultipleResponse.vue?vue&type=template&id=f2351a38&scoped=true"
import script from "./MultipleResponse.vue?vue&type=script&lang=js"
export * from "./MultipleResponse.vue?vue&type=script&lang=js"

import "./MultipleResponse.vue?vue&type=style&index=0&id=f2351a38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2351a38"]])

export default __exports__